var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-navigation-drawer",
        {
          attrs: { app: "", clipped: "", height: "100vh" },
          model: {
            value: _vm.categoryLegend,
            callback: function ($$v) {
              _vm.categoryLegend = $$v
            },
            expression: "categoryLegend",
          },
        },
        [_c("search-navigation")],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isPageInLoadingState,
              expression: "isPageInLoadingState",
            },
          ],
        },
        [
          _c(
            "v-container",
            [
              _c(
                "v-row",
                { staticClass: "mt-10" },
                [
                  _c(
                    "v-col",
                    { staticClass: "text-center" },
                    [
                      _c("v-progress-circular", {
                        attrs: {
                          size: "40",
                          indeterminate: "",
                          color: "primary",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isPageInLoadingState,
              expression: "!isPageInLoadingState",
            },
          ],
        },
        [
          _c(
            "div",
            { staticClass: "breadcrumb-container" },
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        [
                          _c("breadcrumb", {
                            attrs: { items: _vm.breadcrumbItems },
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "pt-3" }, [
                            _c(
                              "h4",
                              { staticClass: "text-h4 font-weight-medium" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.displayActiveCategory) +
                                    "\n                        "
                                ),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.breadcrumbData.description
                            ? _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.breadcrumbData.description
                                  ),
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "grey lighten-5 container-height" },
            [
              _c(
                "v-container",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "9" } },
                        [
                          _vm.isDefaultCodesPage
                            ? _c("default-codes-page")
                            : [
                                _vm.isAstmSubjectPage &&
                                _vm.isAstmCompassEnabled()
                                  ? _c("astm-subjects")
                                  : [
                                      _c("codes-result-navigation-controls", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.showTitles,
                                            expression: "showTitles",
                                          },
                                        ],
                                        attrs: {
                                          category: _vm.searchData.category,
                                          "show-years": _vm.showYearFilter,
                                          loading: _vm.resultsLoading,
                                        },
                                      }),
                                      _vm._v(" "),
                                      _vm.showTitles
                                        ? [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "mb-2 mt-2 font-weight-bold",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.pagination.totalResults
                                                  ) + " titles"
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.pagination.totalResults > 0
                                              ? _c("title-list", {
                                                  attrs: {
                                                    titles: _vm.results,
                                                    loading: _vm.resultsLoading,
                                                    itemsPerPage:
                                                      _vm.itemsPerPage,
                                                    displayBorder: "",
                                                    displayUserTypeLabel: "",
                                                    displayInCols:
                                                      _vm.isMobilePort ? 12 : 6,
                                                  },
                                                })
                                              : _c(
                                                  "v-row",
                                                  {
                                                    attrs: {
                                                      justify: "center",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "v-col",
                                                      {
                                                        attrs: { cols: "auto" },
                                                      },
                                                      [_c("no-results-found")],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                          ]
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.page < _vm.pagination.maxPerPage &&
                                      !_vm.resultsLoading &&
                                      _vm.showTitles
                                        ? _c(
                                            "v-row",
                                            {
                                              attrs: {
                                                dense: "",
                                                justify: "center",
                                              },
                                            },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "auto" } },
                                                [
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      staticClass: "mb-4",
                                                      attrs: {
                                                        text: "",
                                                        color: "primary",
                                                        loading:
                                                          _vm.showMoreLoading,
                                                      },
                                                      on: {
                                                        click: _vm.showMore,
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                          Show More\n                                          "
                                                      ),
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: { right: "" },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                              mdi-chevron-down\n                                          "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showAdditionalOptions &&
                                      _vm.hasAdditionalOptions
                                        ? [
                                            _vm.showTitles
                                              ? _c("v-divider", {
                                                  staticClass: "my-5",
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.showTitles
                                              ? _c(
                                                  "h2",
                                                  {
                                                    staticClass:
                                                      "text-h6 font-weight-medium mb-4",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                Additional Options in " +
                                                        _vm._s(
                                                          _vm.activeCategory
                                                        ) +
                                                        "\n                              "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "v-row",
                                              _vm._l(
                                                _vm.activeCategoryChildCategories,
                                                function (category, index) {
                                                  return _c(
                                                    "v-col",
                                                    {
                                                      key: category.id,
                                                      attrs: {
                                                        cols: "12",
                                                        sm: "6",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        category.fullUrl
                                                          ? "a"
                                                          : "div",
                                                        {
                                                          tag: "component",
                                                          attrs: {
                                                            href:
                                                              category.fullUrl ||
                                                              null,
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-card",
                                                            {
                                                              staticClass:
                                                                "pa-4 hover-border rounded-lg",
                                                              attrs: {
                                                                outlined: "",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "text-body-1 font-weight-medium",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      category.name
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                          ]
                                        : _vm._e(),
                                    ],
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "3" } },
                        [
                          _c("category-tabs", {
                            attrs: {
                              loading:
                                _vm.resultsLoading || _vm.isCategoryDataLoading,
                              "category-data": _vm.categoryData,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }